import MasterComponent from "../../../components/Forms"
import moment from 'moment';
import { FormColumnConfig, MasterConfigs } from "../../../interfaces/entity";
import { Button, Card, Flex, Modal, notification, Space, Typography, Radio, Form, Select, Input, Tag, Dropdown, Menu, message } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../../../actions/apiCall";
import { FormInstance } from "antd/lib";
import dayjs from "dayjs";
import { formatPriceIndian } from "../../../constants/functions";
import PdfView from "../../../components/custom/PDFView";
import Badge from "../../../components/Badge";
import SmallProfileCard from "../../../components/ContactInfo/SmallProfileCard";
import { constants } from "../../../constants/common";
import DrawerComponent from "../../../components/Forms/Drawer";
import ProfileCard from "../../../components/ContactInfo/ProfileCard";
import InvoiceDetails from "../../Leads/Invoices/InvoiceDetails";
import { EditOutlined } from "@ant-design/icons";
import InvoiceSummary from "../../../components/InvoiceSummary";
import axios from "axios";
const { DownloadOutlined, FileExcelOutlined, FilePdfOutlined } = require("@ant-design/icons");
const { Title, Text } = Typography;

const InvoiceJobs = () => {
  const [dealValue, setDealValue] = React.useState(null);
  const [dealData, setDealData] = React.useState()
  const [isContract, setIsContract] = React.useState(false);
  const [form, setForm] = React.useState<FormInstance>(null);
  const [isUpdate, setIsUpdate] = React.useState<any>(null);
  const [pdfURL, setPDFURL] = React.useState<any>(null);
  const [selectedInvoice, setSelectedInvoice] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [summary, setSummary] = useState<any>(null);
  const [exportLoading, setExportLoading] = useState(false);
  const dispatch = useDispatch();
  const query: any = useSelector((app: any) => app?.app?.query);

  const onClose = () => {
    setDealValue(null);
    setDealData(null);
    setIsContract(false);
    setForm(null);
    setIsUpdate(null);
    setPDFURL(null);
    setSelectedInvoice(null);
  }

  const getDealvalue = async (dealId, skipFormUpdate = false) => {
    if (!dealId) {
      return;
    }
    try {
      const resData = await dispatch(getData(`/deals/${dealId}`))
      if (resData?.code == 200) {
        const invoiceSettings = await dispatch(getData('/invoices/settings'));
        if (invoiceSettings.code == 200) {
          const isContractField = invoiceSettings?.data?.contractType === resData?.data?.leadType?._id
          setIsContract(isContractField);
          // Only set form values if not updating (editing) and form is available
          // When editing, form values are already loaded by patchData, so we skip this
          if (!isUpdate && !skipFormUpdate && form) {
            if (isContractField) {
              const isHourlyBilling = resData?.data?.billingType === 'Hourly';
              const developerData: any = {
                developers: resData?.data?.developer?.firstName || '',
                price: resData?.data?.amount || '', // Use amount field for both hourly rate and monthly amount
                includeSaturday: false,
                countAsWorkingDays: true,
              };

              if (isHourlyBilling) {
                // Hourly billing - set hours
                developerData.hours = 180; // Default hours
                developerData.leaves = 0;
                developerData.extraDays = 0;
              } else {
                // Monthly billing - set dates
                developerData.leaves = 0;
                developerData.extraDays = 0;
                developerData.startDate = dayjs(moment().subtract(1, 'months').startOf('month').toDate());
                developerData.endDate = dayjs(moment().subtract(1, 'months').endOf('month').toDate());
              }

              form.setFieldsValue({
                developers: [developerData],
                tds: resData?.data?.tds || 10,
                GST: resData?.data?.gst || 18,
              });
            } else {
              form.setFieldsValue({
                project: [{
                  projectName: resData?.data?.project?.name || '',
                  price: resData?.data?.amount || '',
                }],
                tds: resData?.data?.tds || 10,
                GST: resData?.data?.gst || 18,
              });
            }
          }
        } else {
          setIsContract(false);
        }
        setDealData(resData?.data)
      }

    } catch (error) {
      console.log(error)
    }
  }

  const getObject = (isContract) => {
    if (isContract) {
      return [
        {
          name: 'developers',
          type: 'form',
          span: 24,
          form: [
            {
              label: 'Developer',
              name: 'developers',
              type: 'text',
              rules: [{
                required: true,
                message: 'Developer is required',
              }],
              span: 8,
            },
            {
              label: 'Price',
              name: 'price',
              type: 'number',
              rules: [
                {
                  required: true,
                  message: 'Price is required',
                },
                {
                  validator: (_, value) => {
                    if (value && isNaN(value)) {
                      return Promise.reject(new Error('Price must be a number'));
                    }
                    return Promise.resolve();
                  },
                }],
              span: 8,
            },
            {
              label: 'Hours',
              name: 'hours',
              type: 'number',
              span: 8,
              placeholder: 'Enter hours (for hourly billing)',
            },
            {
              label: 'Start Date',
              name: 'startDate',
              type: 'date',
              rules: [{
                validator: (_, value) => {
                  const hours = form?.getFieldValue(['developers', 0, 'hours']);
                  // Not required if hours is provided (hourly billing)
                  if (hours) {
                    return Promise.resolve();
                  }
                  // Required for monthly billing
                  if (!value) {
                    return Promise.reject(new Error('Start Date is required for monthly billing'));
                  }
                  return Promise.resolve();
                },
              }],
              dateProps: {
                format: 'DD-MM-YYYY',
              },
              span: 8,
            },
            {
              label: 'End Date',
              name: 'endDate',
              rules: [{
                validator: (_, value) => {
                  const hours = form?.getFieldValue(['developers', 0, 'hours']);
                  // Not required if hours is provided (hourly billing)
                  if (hours) {
                    return Promise.resolve();
                  }
                  // Required for monthly billing
                  if (!value) {
                    return Promise.reject(new Error('End Date is required for monthly billing'));
                  }
                  return Promise.resolve();
                },
              }],
              dateProps: {
                format: 'DD-MM-YYYY',
              },
              type: 'date',
              span: 8,
            },
            {
              label: 'Leaves',
              name: 'leaves',
              type: 'number',
              span: 4,
            },
            {
              label: 'Extra Days',
              name: 'extraDays',
              type: 'number',
              span: 4,
              placeholder: 'Enter extra days worked',
            },
            {
              label: 'Saturday Working',
              name: 'includeSaturday',
              type: 'checkbox',
              span: 8,
            },
            {
              label: 'Is Billing for Working days?',
              name: 'countAsWorkingDays',
              type: 'checkbox',
              span: 8,
            },
          ],
        }
      ];
    } else {
      return [
        {
          name: 'project',
          type: 'form',
          span: 24,
          form: [
            {
              label: 'Project Name',
              name: 'projectName',
              type: 'text',
              rules: [{
                required: true,
                message: 'Project Name is required',
              }],
              span: 8,
            },
            {
              label: 'Milestones',
              name: 'milestones',
              type: 'text',
              rules: [{
                required: true,
                message: 'Milestones is required',
              }],
              span: 8,
            },
            {
              label: 'Price',
              name: 'price',
              rules: [{
                required: true,
                message: 'Price is required',
              },
              {
                validator: (_, value) => {
                  if (value && isNaN(value)) {
                    return Promise.reject(new Error('Price must be a number'));
                  }
                  return Promise.resolve();
                },
              }],
              type: 'number',
              span: 8,
            }
          ],
        }
      ];
    }
  };


  const handleGSTExport = async (format: 'excel' | 'pdf') => {
    try {
      setExportLoading(true);

      // Build query parameters from current filters
      const queryParams: any = {
        format: format,
        invoiceStatus: 'paid' // Only export paid invoices
      };

      // Add any additional filters from query state
      if (query?.fields) {
        Object.keys(query.fields).forEach(key => {
          queryParams[key] = query.fields[key];
        });
      }
      if (query?.conditions) {
        Object.keys(query.conditions).forEach(key => {
          queryParams[key] = query.conditions[key];
        });
      }

      // Make request to export endpoint
      const response = await axios.get(`${process.env.API_URL}/invoiceJobs/export/gst`, {
        params: queryParams,
        responseType: 'blob',
      });

      // Check if response is an error (blob with JSON error message)
      if (response.data.type && response.data.type.includes('application/json')) {
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        throw new Error(errorData.message || 'Failed to export GST data');
      }

      // Create blob and download
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      const extension = format === 'pdf' ? 'pdf' : 'xlsx';
      const filename = `gst_portal_export_${moment().format('YYYY-MM-DD_HH-mm-ss')}.${extension}`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success(`GST Portal data exported successfully as ${format.toUpperCase()}`);
    } catch (error: any) {
      console.error('Error exporting GST data:', error);
      let errorMessage = 'Failed to export GST data';

      if (error?.response) {
        if (error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const errorData = JSON.parse(text);
            errorMessage = errorData.message || errorMessage;
          } catch (parseError) {
            errorMessage = error.message || errorMessage;
          }
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        } else if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        }
      } else if (error?.message) {
        errorMessage = error.message;
      }

      message.error(errorMessage);
    } finally {
      setExportLoading(false);
    }
  };

  const handleTDSExport = async (format: 'excel' | 'pdf') => {
    try {
      setExportLoading(true);

      // Build query parameters from current filters
      const queryParams: any = {
        format: format,
        invoiceStatus: 'paid' // Only export paid invoices
      };

      // Add any additional filters from query state
      if (query?.fields) {
        Object.keys(query.fields).forEach(key => {
          queryParams[key] = query.fields[key];
        });
      }
      if (query?.conditions) {
        Object.keys(query.conditions).forEach(key => {
          queryParams[key] = query.conditions[key];
        });
      }

      // Make request to export endpoint
      const response = await axios.get(`${process.env.API_URL}/invoiceJobs/export/tds`, {
        params: queryParams,
        responseType: 'blob',
      });

      // Check if response is an error (blob with JSON error message)
      if (response.data.type && response.data.type.includes('application/json')) {
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        throw new Error(errorData.message || 'Failed to export TDS data');
      }

      // Create blob and download
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      const extension = format === 'pdf' ? 'pdf' : 'xlsx';
      const filename = `tds_export_${moment().format('YYYY-MM-DD_HH-mm-ss')}.${extension}`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success(`TDS data exported successfully as ${format.toUpperCase()}`);
    } catch (error: any) {
      console.error('Error exporting TDS data:', error);
      let errorMessage = 'Failed to export TDS data';

      if (error?.response) {
        if (error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const errorData = JSON.parse(text);
            errorMessage = errorData.message || errorMessage;
          } catch (parseError) {
            errorMessage = error.message || errorMessage;
          }
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        } else if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        }
      } else if (error?.message) {
        errorMessage = error.message;
      }

      message.error(errorMessage);
    } finally {
      setExportLoading(false);
    }
  };

  const invoiceConfig: MasterConfigs = useMemo(() => ({
    api: () => '/invoiceJobs',
    title: 'Invoice Jobs',
    isActionTab: true,
    maskClosable: false,
    onClose: onClose,
    onSummaryLoad: (summaryData) => {
      setSummary(summaryData);
    },
    renderSummary: () => {
      return <InvoiceSummary summary={summary} />;
    },
    modalTitle: (action) => action + ' Invoice',
    onDataLoad: async (e) => {
      if (e?.billTo) {
        setIsUpdate(e);
        // Determine if it's a contract invoice from the data itself
        // Check if developers array exists and has data (contract) vs project array (fix bid)
        const isContractInvoice = e?.developers && Array.isArray(e.developers) && e.developers.length > 0;
        // Set isContract immediately so form columns can be determined correctly
        setIsContract(isContractInvoice);

        // Initialize nonTaxable and grossDeductions with at least one empty object if empty
        // This ensures the form fields are visible even when these arrays are empty
        if (!e.nonTaxable || !Array.isArray(e.nonTaxable) || e.nonTaxable.length === 0) {
          e.nonTaxable = [{}];
        }
        if (!e.grossDeductions || !Array.isArray(e.grossDeductions) || e.grossDeductions.length === 0) {
          e.grossDeductions = [{}];
        }

        // When editing, form values are already loaded by patchData
        // We only need to fetch deal data for contract type detection, but skip form value updates
        // Use setTimeout to ensure state update happens before form re-renders
        setTimeout(() => {
          getDealvalue(e?.billTo, true);
        }, 0);
      }
    },
    setForm: (e) => setForm(e),
    getFilterColumns: () => {
      return [
        {
          label: 'Account (Client Company)',
          name: 'billToFilter',
          type: 'select',
          isCombo: true,
          span: 6,
          selectProps: {
            showSearch: true,
            allowClear: true,
            placeholder: 'Select Account',
          },
        },
        {
          label: 'Developer',
          name: 'developer',
          type: 'text',
          span: 6,
          placeholder: 'Search by developer name',
        },
        {
          type: 'custom',
          span: 6,
          formItem: (form) => {
            const InvoiceStatusFilter = () => {
              return (
                <Form.Item label="Invoice Status" name="invoiceStatus">
                  <Space.Compact style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <Form.Item name="invoiceStatusFilterType" initialValue="include" style={{ margin: 0, width: '120px' }}>
                      <Select style={{ width: '120px' }}>
                        <Select.Option value="include">Include</Select.Option>
                        <Select.Option value="exclude">Exclude</Select.Option>
                      </Select>
                    </Form.Item>
                    <Form.Item name="invoiceStatus" style={{ margin: 0, flex: 1 }}>
                      <Select
                        mode="multiple"
                        allowClear
                        placeholder="Select Status"
                        style={{ width: '100%' }}
                        maxTagCount="responsive"
                      >
                        <Select.Option value="draft">Draft</Select.Option>
                        <Select.Option value="sent">Sent</Select.Option>
                        <Select.Option value="paid">Paid</Select.Option>
                        <Select.Option value="partially_paid">Partially Paid</Select.Option>
                        <Select.Option value="overdue">Overdue</Select.Option>
                        <Select.Option value="cancelled">Cancelled</Select.Option>
                        <Select.Option value="void">Void</Select.Option>
                        <Select.Option value="refunded">Refunded</Select.Option>
                      </Select>
                    </Form.Item>
                  </Space.Compact>
                </Form.Item>
              );
            };
            return <InvoiceStatusFilter />;
          },
        },
        {
          label: 'Invoice Month',
          name: 'invoiceMonth',
          type: 'date',
          span: 6,
          dateProps: {
            picker: 'month',
            format: 'MMM YYYY',
            allowClear: true,
            placeholder: 'Select Month',
          },
        },
        {
          label: 'Start Date',
          name: 'startDate',
          type: 'date',
          filterType: 'date',
          span: 6,
          dateProps: {
            format: 'DD MMM, YYYY',
            allowClear: true,
            placeholder: 'Select Start Date',
          },
        },
        {
          label: 'End Date',
          name: 'endDate',
          type: 'date',
          filterType: 'date',
          span: 6,
          dateProps: {
            format: 'DD MMM, YYYY',
            allowClear: true,
            placeholder: 'Select End Date',
          },
        },
        {
          label: 'Due Date From',
          name: 'dueDateFrom',
          type: 'date',
          filterType: 'date',
          span: 6,
          dateProps: {
            format: 'DD-MM-YYYY',
            allowClear: true,
            placeholder: 'Due Date From',
          },
        },
        {
          label: 'Due Date To',
          name: 'dueDateTo',
          type: 'date',
          filterType: 'date',
          span: 6,
          dateProps: {
            format: 'DD-MM-YYYY',
            allowClear: true,
            placeholder: 'Due Date To',
          },
        },
      ];
    },
    getColumns: () => {
      return [
        {
          title: 'Invoice Number',
          dataIndex: 'invoiceNumber',
          key: 'invoiceNumber',
          width: 150,
          fixed: 'left',
          align: 'left',
          render: (value, records) => {
            // Get start and end dates from developers array
            let startDate = null;
            let endDate = null;

            if (records?.developers && Array.isArray(records.developers) && records.developers.length > 0) {
              const dates = records.developers
                .filter(dev => dev.startDate || dev.endDate)
                .map(dev => ({
                  start: dev.startDate ? moment(dev.startDate) : null,
                  end: dev.endDate ? moment(dev.endDate) : null
                }));

              if (dates.length > 0) {
                const validStarts = dates.map(d => d.start).filter(d => d && d.isValid());
                const validEnds = dates.map(d => d.end).filter(d => d && d.isValid());

                if (validStarts.length > 0) {
                  startDate = moment.min(validStarts);
                }
                if (validEnds.length > 0) {
                  endDate = moment.max(validEnds);
                }
              }
            }

            return (
              <div style={{ textAlign: 'left' }}>
                <div style={{ textAlign: 'left' }}>
                  <Button type="link" className="text-left !p-0" size="small" onClick={() => handleLeadClick(records)}>{value}</Button>
                </div>
                {(startDate || endDate) && (
                  <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: '-2px' }}>
                    {startDate && endDate
                      ? `${startDate.format('DD MMM')} - ${endDate.format('DD MMM')}, ${endDate.format('YYYY')}`
                      : startDate
                        ? `From: ${startDate.format('DD MMM, YYYY')}`
                        : endDate
                          ? `To: ${endDate.format('DD MMM, YYYY')}`
                          : ''
                    }
                  </div>
                )}
              </div>
            );
          },
        },
        {
          title: 'Bill TO',
          dataIndex: 'billTo',
          key: 'billTo',
          fixed: 'left',
          width: 200,
          render: (value) => {
            if (!value) return '-';
            return (
              <div>
                <div>{value.dealName || '-'}</div>
                {value?.business?.businessName && (
                  <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: '2px' }}>
                    {value.business.businessName}
                  </div>
                )}
              </div>
            );
          },
        },
        {
          title: 'GST Amount',
          dataIndex: 'gstAmount',
          key: 'gstAmount',
          width: 150,
          render: (value) => {
            return value ? `₹ ${formatPriceIndian(value)}` : '-';
          }
        },
        {
          title: 'TDS Amount',
          dataIndex: 'tdsAmount',
          key: 'tdsAmount',
          width: 150,
          render: (value) => {
            return value ? `₹ ${formatPriceIndian(value)}` : '-';
          }
        },
        {
          title: 'Bill Amount',
          dataIndex: 'totalBill',
          key: 'totalBill',
          width: 150,
          render: (value) => {
            return value ? `₹ ${formatPriceIndian(value)}` : '-';
          }
        },
        {
          title: 'Invoice Status',
          dataIndex: 'invoiceStatus',
          key: 'invoiceStatus',
          align: 'center',
          width: 200,
          render: (value, record) => {
            if (value === 'draft') {
              return <Badge color="blue" text="Draft" />;
            }
            if (value === 'sent') {
              return <Badge color="orange" text="Sent" />;
            }
            if (value === 'paid') {
              return <Badge color="green" text="Paid" />;
            }
            if (value === 'cancelled') {
              return <Badge color="red" text="Cancelled" />;
            }
            if (value === 'overdue') {
              return <Badge color="red" text={`Overdue by ${moment(value).fromNow()}`} />;
            }
            if (value === 'partially_paid') {
              return <Badge color="yellow" text="Partially Paid" />;
            }
            if (value === 'refunded') {
              return <Badge color="purple" text="Refunded" />;
            }
            if (value === 'void') {
              return <Badge color="gray" text="Void" />;
            }
          }
        },
        {
          title: 'Due Date',
          dataIndex: 'dueDate',
          key: 'dueDate',
          align: 'center',
          width: 200,
          render: (value, record) => {
            return moment(value).isBefore(moment(), 'day') ? <Badge color="red" text={`Overdue by ${moment(value).fromNow()}`} /> : moment(value).format('DD MMM, YYYY');
          },
        },
        {
          title: 'Invoice Sent On',
          dataIndex: 'invoiceSentAt',
          key: 'invoiceSentAt',
          align: 'center',
          width: 150,
          render: (value) => {
            return value ? moment(value).format('DD MMM, YYYY') : <Badge color="yellow" text="Waiting" />;
          },
        },
        {
          title: 'Invoice',
          dataIndex: 'invoiceFile',
          key: 'invoiceFile',
          align: 'center',
          width: 150,
          render: (value, record) => {
            return value ? <Button onClick={() => {
              setPDFURL(value)
              setSelectedInvoice(record)
            }} type="link">View Invoice</Button> : 'No Invoice';
          },
        },
        {
          title: 'Created At',
          dataIndex: 'createdAt',
          key: 'createdAt',
          align: 'center',
          width: 150,
          render: (value) => {
            return moment(value).format('LLL');
          },
        },
        {
          title: 'Invoice Owner',
          dataIndex: 'invoiceOwner',
          key: 'invoiceOwner',
          align: 'center',
          width: 150,
          render: (value) => {
            return value ? <SmallProfileCard
              name={constants.GET_FULL_NAME(value)}
              avatar={value?.avatar}
            /> : 'No Owner';
          },
        }
      ];
    },
    getFormColumns: () => {
      // Determine contract type - use current state
      // When editing, isContract should already be set from onDataLoad
      return [
        {
          label: 'Bill From',
          name: 'billFrom',
          type: 'select',
          isCombo: true,
          rules: [
            {
              required: true,
              message: 'Please select a Bill From',
            },
          ],
        },
        {
          label: 'Bill To',
          name: 'billTo',
          type: 'select',
          isCombo: true,
          selectProps: {
            onChange: (e) => {
              getDealvalue(e);
            },
          },
          rules: [
            {
              required: true,
              message: 'Please select a Bill To',
            },
          ],
        },
        {
          type: 'custom',
          span: 24,
          formItem: (text) => <Title level={5}>Billing Information</Title>
        },
        ...getObject(isContract),
        {
          type: 'custom',
          span: 24,
          formItem: (text) => <Title level={5}>Taxes</Title>
        },
        {
          label: 'TDS',
          name: 'tds',
          lebelInstructions: 'Value will be count as percentage(%)',
          type: 'number',
        },
        {
          label: 'GST',
          name: 'GST',
          lebelInstructions: 'Value will be count as percentage(%)',
          type: 'number',
        },
        {
          type: 'custom',
          span: 24,
          formItem: (text) => <Title level={5}>Non Taxable (Bonus / Commission)</Title>
        },
        {
          name: 'nonTaxable',
          type: 'form',
          span: 24,
          form: [
            {
              label: 'Component Name',
              name: 'componentName',
              type: 'text',
              span: 8,
            },
            {
              label: 'Amount',
              name: 'amount',
              type: 'text',
              rules: [{
                validator: (_, value) => {
                  if (value && isNaN(value)) {
                    return Promise.reject(new Error('Amount must be a number'));
                  } else {
                    return Promise.resolve();
                  }
                }
              }],
              span: 8,
            },
          ]
        },
        {
          type: 'custom',
          span: 24,
          formItem: (text) => <Title level={5}>Gross Deductions</Title>
        },
        {
          name: 'grossDeductions',
          type: 'form',
          span: 24,
          form: [
            {
              label: 'Component Name',
              name: 'componentName',
              type: 'text',
              span: 8,
            },
            {
              label: 'Amount',
              name: 'amount',
              type: 'text',
              rules: [{
                validator: (_, value) => {
                  if (value && isNaN(value)) {
                    return Promise.reject(new Error('Amount must be a number'));
                  } else {
                    return Promise.resolve();
                  }
                }
              }],
              span: 8,
            },
          ]
        },
        {
          label: 'Invoice Date',
          name: 'invoiceDate',
          type: 'date',
          dateProps: {
            format: 'DD-MM-YYYY',
            onChange: (date, dateString) => {
              if (date && form) {
                form.setFieldsValue({ dueDate: dayjs(date).add(7, 'day') });
              }
            },
          },
        },
        {
          label: 'Due Date',
          name: 'dueDate',
          type: 'date',
          dateProps: {
            format: 'DD-MM-YYYY',
          },
        },
        {
          label: 'Timesheet',
          name: 'timesheet',
          type: 'file',
          multiple: true,
        },
      ].filter(Boolean) as FormColumnConfig[];
    },
    combo: [
      {
        name: 'billTo',
        api: '/invoiceJobs/won-deals',
        idKey: '_id',
        render: (text) => `${text.dealName}${text.businessName ? ` - ${text.businessName}` : ''}`,
      },
      {
        name: 'billToFilter',
        api: '/invoiceJobs/accounts',
        idKey: '_id',
        render: (text) => text.businessName || text.name || '',
      },
      {
        name: 'billFrom',
        api: '/bank-accounts',
        idKey: '_id',
        render: (text) => <>{text.beneficiaryName} - ({text.ifscNumber})</>
      },
    ],
    getData: () => ({}),
    actions: [
      {
        actionType: 'Add',
        name: 'Add Invoice Job',
      },
      {
        actionType: 'filter',
        name: 'Filter',
      },
      {
        name: 'Export',
        actionType: 'Custom',
        render: () => (
          <Dropdown
            overlay={
              <Menu>
                <Menu.ItemGroup title="GST Portal Export">
                  <Menu.Item
                    key="gst-excel"
                    icon={<FileExcelOutlined style={{ fontSize: '16px', color: '#52c41a' }} />}
                    onClick={() => handleGSTExport('excel')}
                    disabled={exportLoading}
                  >
                    Export GST as Excel
                  </Menu.Item>
                  <Menu.Item
                    key="gst-pdf"
                    icon={<FilePdfOutlined style={{ fontSize: '16px', color: '#ff4d4f' }} />}
                    onClick={() => handleGSTExport('pdf')}
                    disabled={exportLoading}
                  >
                    Export GST as PDF
                  </Menu.Item>
                </Menu.ItemGroup>
                <Menu.Divider />
                <Menu.ItemGroup title="TDS Export">
                  <Menu.Item
                    key="tds-excel"
                    icon={<FileExcelOutlined style={{ fontSize: '16px', color: '#52c41a' }} />}
                    onClick={() => handleTDSExport('excel')}
                    disabled={exportLoading}
                  >
                    Export TDS as Excel
                  </Menu.Item>
                  <Menu.Item
                    key="tds-pdf"
                    icon={<FilePdfOutlined style={{ fontSize: '16px', color: '#ff4d4f' }} />}
                    onClick={() => handleTDSExport('pdf')}
                    disabled={exportLoading}
                  >
                    Export TDS as PDF
                  </Menu.Item>
                </Menu.ItemGroup>
              </Menu>
            }
            trigger={['click']}
          >
            <Button
              type="default"
              icon={<DownloadOutlined />}
              loading={exportLoading}
            >
              Export
            </Button>
          </Dropdown>
        ),
      }
    ]
  }), [isContract, dealValue, summary, query, exportLoading]);

  const onSendInvoice = async () => {
    try {
      if (!selectedInvoice) {
        return
      }
      setLoading(true);
      const resData = await dispatch(getData(`/invoiceJobs/send/mail/${selectedInvoice?._id}`));
      if (resData?.code == 200) {
        notification.success({
          message: 'Success',
          description: 'Invoice sent successfully',
        })
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const handleLeadClick = (record) => {
    setSelectedInvoice(record);
    setOpenDrawer(true);
  }

  const handleEditClick = (invoice) => {
    setSelectedInvoice(invoice);
    setOpenDrawer(true);
  }

  return <>
    <Modal
      title={"Invoice PDF"}
      open={!!pdfURL} onCancel={() => setPDFURL(null)} width={1000}
      onOk={() => onSendInvoice()}
      okButtonProps={{ loading: loading }}
      okText={"Send Mail"}
    >
      <PdfView url={process.env.FILE_URL + pdfURL} isToolbar={true} />
    </Modal>
    <MasterComponent config={invoiceConfig} />
    <DrawerComponent
      title={
        <Flex justify="space-between" align="center" gap={2} style={{ width: '95%' }}>
          {selectedInvoice?.invoiceNumber}
        </Flex>
      }
      visible={openDrawer}
      handleCancel={() => setOpenDrawer(false)}
      isView={true}
      loading={false}
      submitForm={() => { }}
      rest={{
        width: '90%', style: {
          background: '#eef1f9',
          padding: '0px !important',
        },
        bodyStyle: { padding: 0 },
        headerStyle: { background: '#FFFFFF', padding: '8px 10px' },
      }}
    >
      <InvoiceDetails invoice={selectedInvoice} />
    </DrawerComponent>
  </>
}

export default InvoiceJobs;